import * as React from 'react';
import Alert, { AlertCategoryEnum } from '../../../misc/components/Alert';
import Select, { ActionMeta, OnChangeValue, StylesConfig } from 'react-select';
import { CoughAnalysisSet } from 'webportalclient';
import { DateTimeAccuracy, FormatTime } from '../../../misc/components/LocalizedDateTime';
import { CoughAnalysisSetTypeEnum } from "../../../misc/api/CoughAnalysisSetTypes";

export interface SelectPrimaryAnalysisSetFormProps {
    error: string | undefined;
    analysisSetOptions: Array<CoughAnalysisSet>;
    selectedAnalysisSets: CoughAnalysisSet[];
    onSubmit: () => void;
    onChange: (values) => void;
    onClose: () => void;
}

export const SelectPrimaryAnalysisSetForm = (props: SelectPrimaryAnalysisSetFormProps) => {
    const onChange = (
        newValue: OnChangeValue<CoughAnalysisSet, true>,
        actionMeta: ActionMeta<CoughAnalysisSet>
    ) => {
        switch (actionMeta.action) {
            case 'remove-value':
            case 'pop-value':
                if (actionMeta.removedValue.type === CoughAnalysisSetTypeEnum.QualityCheck || actionMeta.removedValue.type === CoughAnalysisSetTypeEnum.DeviceEvents) {
                    return;
                }
                break;
            case 'clear':
                newValue = props.selectedAnalysisSets.filter((a) => a.type === CoughAnalysisSetTypeEnum.QualityCheck || a.type === CoughAnalysisSetTypeEnum.DeviceEvents);
                break;
        }

        props.onChange(newValue);
    };

    const styles: StylesConfig<CoughAnalysisSet, true> = {
        multiValue: (base, state) => {
            return state.data.type === CoughAnalysisSetTypeEnum.QualityCheck || state.data.type === CoughAnalysisSetTypeEnum.DeviceEvents
                ? { ...base, backgroundColor: '#e4e4e4' }
                : base;
        },
        multiValueLabel: (base, state) => {
            return state.data.type === CoughAnalysisSetTypeEnum.QualityCheck || state.data.type === CoughAnalysisSetTypeEnum.DeviceEvents
                ? { ...base, fontWeight: 'bold', paddingRight: 6 }
                : base;
        },
        multiValueRemove: (base, state) => {
            return state.data.type === CoughAnalysisSetTypeEnum.QualityCheck || state.data.type === CoughAnalysisSetTypeEnum.DeviceEvents
                ? { ...base, display: 'none' }
                : base;
        },
    };

    return (
        <>
            <div className='modal-body'>
                <div className='row'>
                    <div className='col-md-12 form-group'>
                        <Alert show={true} category={AlertCategoryEnum.Info}>
                            <p>Select one analysis sets to be marked as primary. Primary analysis sets will be used for reporting and further analysis. You can change the primary analysis sets at any time.</p>

                            <p>QC and Subject analysis sets for the session will automatically be included.</p>
                        </Alert>
                        <Alert show={props.error !== undefined} category={AlertCategoryEnum.Danger}>
                            {props.error}
                        </Alert>
                        <label>Primary Analysis Sets</label>
                        <Select
                            styles={styles}
                            classNamePrefix="PrimaryAnalysisSets"
                            options={props.analysisSetOptions}
                            value={props.selectedAnalysisSets}
                            getOptionValue={o => o.id}
                            getOptionLabel={o => `${o.typeName} - ${FormatTime(o.created, DateTimeAccuracy.Minute, false)} (${o.statusName})`}
                            onChange={onChange}
                            isMulti
                            isClearable={props.selectedAnalysisSets.some(a => a.type !== CoughAnalysisSetTypeEnum.QualityCheck && a.type !== CoughAnalysisSetTypeEnum.DeviceEvents) }
                        />
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button className='btn btn-primary' onClick={() => props.onSubmit()}>
                    Set Primary
                </button>
                <button className='btn btn-primary btn-outline' onClick={() => props.onClose()}>
                    Close
                </button>
            </div>
        </>            
    );
}
